import React from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { LiliDropdown } from '../../../DesignSystem/LiliDropdown/LiliDropdown';
import { ControllerWrapper } from '../../../hooks/providers/ControllerWrapper';
import { ChangePersonalAddressEnum, statesList } from '../logic/ChangePersonalAddressSchema';
import { LiliTextInput } from '../../../DesignSystem/LiliTextInput/LiliTextInput';
import { useChangeAddressStepHook } from '../logic/useStepHook';

export interface FormViewProps {
  handleClick: () => void;
  isLoading?: boolean;
  buttonTitle: string;
  control: any;
}

export const FormView = ({ handleClick, buttonTitle, isLoading, control }: FormViewProps) => {
  const { isValid, isDirty } = useFormState();
  const { setError } = useFormContext();
  const { t } = useChangeAddressStepHook({ setError });

  return (
    <div className='flex flex-col items-center justify-center  '>
      <div className='min-w-[440px] pb-[3px]'>
        <div className='w-full h-[80px]'>
          <ControllerWrapper name={ChangePersonalAddressEnum.street} control={control}>
            {({ value, onChange, onBlur, error }) => (
              <LiliTextInput
                title={t('CHANGE_ADDRESS.FORM.STREET')}
                errorMessage={error?.message}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                id='street-input'
                isOnclearButtonVisible={false}
              />
            )}
          </ControllerWrapper>
        </div>
        <div className='flex w-full '>
          <div className='w-full h-[80px]'>
            <ControllerWrapper name={ChangePersonalAddressEnum.apt} control={control}>
              {({ value, onChange, onBlur, error }) => (
                <LiliTextInput
                  title={t('CHANGE_ADDRESS.FORM.APT')}
                  errorMessage={error?.message}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  id='apt-input'
                  isOnclearButtonVisible={false}
                />
              )}
            </ControllerWrapper>
          </div>
        </div>
        <div className='w-full h-[80px]'>
          <ControllerWrapper name={ChangePersonalAddressEnum.city} control={control}>
            {({ value, onChange, onBlur, error }) => (
              <LiliTextInput
                title={t('CHANGE_ADDRESS.FORM.CITY')}
                errorMessage={error?.message}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                id='city-input'
                isOnclearButtonVisible={false}
              />
            )}
          </ControllerWrapper>
        </div>
        <div className='flex w-full h-[80px] gap-[15px]'>
          <div className='w-[85%] '>
            <ControllerWrapper name={ChangePersonalAddressEnum.state} control={control}>
              {({ value, onChange }) => (
                <LiliDropdown
                  items={statesList}
                  title={t('CHANGE_ADDRESS.FORM.STATE')}
                  onSelect={(item) => onChange(item.value)}
                  selectedDropDownItem={statesList.find((state) => state.value === value)}
                  onClear={() => onChange('')}
                  className='h-[54px]'
                  showClose={false}
                  id='stateDropDown'
                />
              )}
            </ControllerWrapper>
          </div>
          <div className='w-full'>
            <ControllerWrapper name={ChangePersonalAddressEnum.zip} control={control}>
              {({ value, onChange, onBlur, error }) => (
                <LiliTextInput
                  title={t('CHANGE_ADDRESS.FORM.ZIP')}
                  errorMessage={error?.message}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  maxLength={5}
                  id='zip-input'
                  isOnclearButtonVisible={false}
                />
              )}
            </ControllerWrapper>
          </div>
        </div>
      </div>
      <LiliButton
        id='address-submit'
        title={buttonTitle}
        disabled={!isValid || !isDirty}
        isLoading={isLoading}
        onClick={() => handleClick()}
        type={LiliButtonType.PRIMARY}
        className='w-[440px] h-[44px]'
      />
    </div>
  );
};
